The identifier for the `ApplicationQuestionnaire`.
